<template>
  <div>
    <router-view name="createTaxonomy" />
    <router-view name="editTaxonomy" />
    <transition name="fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
</style>
